import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Button } from '../button/Button';
import { Icon } from '../icon/Icon';

const block = bemBlock('n-modal-close');

interface ModalCloseProps {
  className?: string;
  onClose?: () => void;
}

const ModalClose: React.FC<ModalCloseProps> = ({ className, onClose, ...props }) => {
  const cssClass = block({ extra: className });
  return (
    <Button
      className={cssClass}
      variant="transparent"
      size="lg"
      onClick={onClose}
      square
      data-role="modal-close"
      {...props}
    >
      <Icon glyph="cross" />
    </Button>
  );
};

export default ModalClose;
